import { Component, ElementRef, OnInit, ViewChild,HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  CommonUtility, ServerConstantsService, DataService, SINGLE_ROW_HEADER, ComponentSummary,
  Components, DateUtility, AgGridUtility, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE,
  AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, Task, WpPerson, WpReferral, EmploymentPlan, EmploymentPlanSummary
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { GridOptions } from 'ag-grid';
import { HoursEditorComponent } from '../shared/components/hours-editor.component';
import { EmploymentPlansSummary } from '../shared/model/employment-plans-summary.model';
import { EmploymentPlans } from '../shared/model/employment-plans.model';
@Component({
  selector: 'app-track-component',
  templateUrl: './track-component.component.html',
  styleUrls: ['./track-component.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TrackComponentComponent implements OnInit {
  @ViewChild('header') header: ElementRef;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(event.target.id == 'myModal'){
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    }
  }
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  serverConstants: any;
  monthDropDown;
  isMonthExist;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;

  defaultColDef;
  editType;
  gridApi;
  loaderFocus : Boolean = false;
  context: any;
  columnDefs: any;
  trackData = [];
  rowSelection;
  gridColumnApi;
  frameworkComponents;
  gridOptions;
  showError = false;
  validationError = [];

  userActionNotificationsMap: any;
  componentTypeDescJson;
  metPlanDescJson;
  componentTypeDescMap;
  trackStatusDescMap;
  trackStatusDescReverseJson;

  metPlanArray = [];
  empPlanId;
  isShowStyle = false;
  component: Components[];
  day;
  selectedMonth = 'All Open';
  isDisabled = false;
  empStartDt;
  empEndDt;
  sharedData;
  readOnly = false;
  tabToNextCell: any;
  tabIndex: any = '-1';
  selectedEmploymentPlan;
  isCurrentEnrollment:Boolean = false;
  employmentArray = [];
  employmentPlan: EmploymentPlan;
  employmentPlans: EmploymentPlans[];
  employmentPlanSummary: EmploymentPlanSummary;
  empPlanStatusMap: any;
  overAllProgressComponents = [];
  auditColumnDefs: any;
  alerts:any = [];
  alertsClone:any =[];

  constructor(private route: Router,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('COMPS') === undefined) {
      this.router.navigate(['/task']);
    }

  }


  ngOnInit() {
    this.overAllProgressComponents = [];
    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get('COMPS').innerNavPages.find(x => x.pageId === 'COMTC').readOnly;
    if (this.readOnly) {
      this.tabIndex = '0';
    }
    this.monthDropDown = ['All Open'];
    this.isMonthExist = [];
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    const componentTypeDesc = this.data.getValueFromSharedDataMap('COMPONENTS');
    this.componentTypeDescJson = this.commonUtil.createNativeMapFromList(componentTypeDesc);
    this.componentTypeDescMap = this.commonUtil.createMapFromList(componentTypeDesc);
    const empPlanStatusArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_PLAN_STATUS');
    this.empPlanStatusMap = this.commonUtil.createNativeMapFromList(empPlanStatusArray);
    const metPlanDesc = this.data.getValueFromSharedDataMap('METPLAN');


    this.metPlanDescJson = this.commonUtil.createNativeMapFromList(metPlanDesc);
    metPlanDesc.forEach(element => {
      if (element.value !== 'GG' && element.value !== 'GN') {
        this.metPlanArray.push(element.name);
      }
    });
    this.trackStatusDescMap = this.commonUtil.createMapFromList(metPlanDesc);
    this.trackStatusDescReverseJson = this.commonUtil.createReverseNativeMapFromList(metPlanDesc);

    // Shared object access to get personId and componentId
    this.sharedData = this.dataService.getSharedDataObject();

    this.getColumnDefinitions();
    // Audit Method
    this.auditColumnDefinations();
    this.employmentPlanSummary = new EmploymentPlanSummary();
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.employmentPlanSummary.etEnrollmentId = Number(this.sharedData.get('etEnrollment').id);
    }

    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      const request = new RequestLoadAllEmpPlans(parseInt(this.sharedData.get('wpPersonId')));
      this.loademploymentPlan(request);
    }  

  }

  reloadData(event) {
    this.loaderFocus = true;
    this.reloadComponents();
  }

  reloadComponents() {
    if (this.selectedEmploymentPlan !== undefined && this.selectedEmploymentPlan.length > 0) {
      console.log('this.selectedEmploymentPlan =' + this.selectedEmploymentPlan);
      if(this.selectedEmploymentPlan.includes('Prior Enrollment')){
        this.isCurrentEnrollment = false;
      } else{
        this.isCurrentEnrollment = true;
      }
      const arrayObj = this.selectedEmploymentPlan.split(' - ');
  
      if (arrayObj.length === 2 || arrayObj.length === 3) {
        const empId = Number(arrayObj[0]);
        this.employmentPlans.forEach(element => {
          this.overAllProgressComponents.push(element.id);
          if (element.id === empId) {
            this.employmentPlan = element;
            this.dataService.addValueToSharedDataMap('selectedEPForComponent', this.selectedEmploymentPlan);
            if (this.employmentPlan.id > 0) {
              const request = new RequestLoad(this.employmentPlan.id,
                this.employmentPlan.empPlanStartDt, this.employmentPlan.estimatedCompletionDt,'N');
              this.load(request);
            }
          }
        });
        this.dataService.addValueToSharedDataMap('overAllProgressComponents', this.overAllProgressComponents);
      }
    }

  }
  loademploymentPlan(request) {
    this.http.post<EmploymentPlansSummary>(this.serverConstants.SERVER_API_URL + '/employmentplan/list',
      request).subscribe(
        (data: EmploymentPlansSummary) => {
          if (data.hasOwnProperty('errorCode')) {
            this.notificationService.error('EmploymentPlan Summary', this.userActionNotificationsMap.ERROR);
          } else {
            if (data != null) {

              if (data.employmentPlans.length > 0) {
                this.employmentPlans = data.employmentPlans;
                this.employmentPlans.forEach(element => {
                  if(element.enrollmentEndDt != null && element.enrollmentEndDt != undefined && element.enrollmentEndDt != 'Current')
                    this.employmentArray.push(element.id + ' - ' + this.empPlanStatusMap[element.empPlanStatusCd] + ' - Prior Enrollment ');
                  else 
                    this.employmentArray.push(element.id + ' - ' + this.empPlanStatusMap[element.empPlanStatusCd]);
        
                });
                const existingEmp = this.sharedData.get('selectedEPForComponent');
                if (existingEmp !== undefined && existingEmp !== null && existingEmp !== '') {
                  this.selectedEmploymentPlan = existingEmp;
                  this.empPlanId = Number((this.selectedEmploymentPlan.split('-'))[0]);
                  this.reloadComponents();

                } else {
                  this.selectedEmploymentPlan = this.employmentArray[0];
                  this.empPlanId = Number((this.selectedEmploymentPlan.split('-'))[0]);
                  this.reloadComponents();
                }
              } else {

              }
            }
          }
        }, response => {

          this.notificationService.error('CaseNotes Summary', this.userActionNotificationsMap.ERROR);
        }, () => {

        });
  }


  saveAll() {
    let allTracks: TrackComponent[] = [];
    this.validationError = [];
    this.showError = false;
    let errorIndex = 0;
    let isHeaderPushed = false;
    this.alerts = [];


    if (this.gridApi !== undefined) {

      this.gridApi.stopEditing();
      this.isShowStyle = true;
      this.gridApi.redrawRows();
      this.isShowStyle = false;

      this.gridApi.selectAll();
      allTracks = this.gridApi.getSelectedRows();
      this.gridApi.deselectAll();



      let taskFlag = true;
      allTracks.forEach(element => {
        let errorText = '';
        ++errorIndex;

        const month = element.month.trim().split('/');
        element.month = month[1] + '/' + month[0] + '/' + this.day;

        if (element.metPlanCd === undefined || element.metPlanCd === 'Pick an option') {
          errorText = 'Met Plan, ';
        }
        element.metPlanCd = this.trackStatusDescReverseJson[element.metPlanCd];
        console.log(this.alertsClone);
        this.alertsClone.forEach((alrt)=>{
          if((alrt.id == element['id']) && (element.completedHours != alrt.hours) && ((element.reportedHours != null) && parseFloat(element.completedHours) < element.reportedHours)){
            this.alerts.push(element);
          }
        })

        if (element.completedHours === null && element.metPlanCd !== 'IN') {
          errorText = errorText + 'Completed, ';
        }
        if (errorText.length > 0) {
          if (!isHeaderPushed) {
            isHeaderPushed = true;
            this.validationError.push('Following fields are mandatory:');
          }

          errorText = errorText.substring(0, errorText.length - 2);
          this.validationError.push('Row ' + errorIndex + ': ' + errorText);
          this.showError = true;
        }

        if (element.metPlanCd === 'IN') {
          taskFlag = false;
        }

      });

      if (!this.showError) {


        const request = new RequestLoadAll(this.trackData, this.component);
        if (taskFlag) {

          const referralId = this.sharedData.get('referralId');
          const providerId = this.sharedData.get('providerId');
          let personId = 0;
          if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
            personId = Number(this.sharedData.get('wpPersonId'));
          }

          let indicator = 'C';
          let assignedTo = 0;
          if (providerId > 0) {
            assignedTo = providerId;
            indicator = 'P';
          } else {
            const personProvider = this.sharedData.get('personProvider');
            if (personProvider !== undefined && personProvider != null && personProvider.id !== undefined) {

              assignedTo = personProvider.id.serviceCounty;

            }
          }


          const wpPerson = new WpPerson();
          wpPerson.id = personId;
          const wpReferral = new WpReferral();
          wpReferral.id = Number(referralId);

          const oldTask = new Task();

          oldTask.assignedTo = String(assignedTo);
          oldTask.assignedToInd = indicator;
          oldTask.taskType = 'MT';
          oldTask.wpReferral = wpReferral;
          oldTask.wpPerson = wpPerson;
          request.oldTask = oldTask;
        }


        this.http.post<TrackComponent[]>(this.serverConstants.SERVER_API_URL + '/component/track-save', request).subscribe(
          (data) => {
            this.closeModal();
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
            } else {
              this.notificationService.success('Track Component', this.userActionNotificationsMap.ADD);
              this.createAlert();
              if (this.empPlanId > 0) {

                this.load(new RequestLoad(this.empPlanId, this.empStartDt, this.empEndDt,'N'));


              }
            }
          }, response => {
            this.closeModal();
            this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
          }, () => {

          });
      } else {
        this.closeModal();
        allTracks.forEach(element => {
          element.metPlanCd = this.metPlanDescJson[element.metPlanCd];
          const month = element.month.trim().split('/');
          element.month = month[1] + '/' + month[0];
        });
      }
    }
  }

  StatusChange(event) {
    if (this.selectedMonth === 'All Open') {
      this.gridApi.setQuickFilter('');
    } else {
      this.gridApi.setQuickFilter(this.selectedMonth);
    }

  }

  load(request) {
    this.trackData = [];
    this.alertsClone = [];
    this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/component/track-load', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== null && data.tracks !== null && data.tracks.length > 0) {
            data.tracks.forEach((element)=>{
              let req = {
                id:element['id'],
                hours:element['completedHours']
              }
                this.trackData.push(element);
                this.alertsClone.push(req);
            })
            //this.alertsClone = data.tracks.slice(0);
            //this.trackData = data.tracks;
            this.monthDropDown = ['All Open'];
            this.isMonthExist = [];

            this.trackData.sort((a, b) => new Date(b.month).getTime() - new Date(a.month).getTime());

            this.trackData.forEach(element => {
              const date = element.month.trim().split('/');
              if (!this.monthDropDown.includes(date[1] + '/' + date[0])) {
                this.monthDropDown.push(date[1] + '/' + date[0]);

              }
              if (!this.isMonthExist.includes(date[1] + '/' + date[0] + element.component.id)) {
                this.isMonthExist.push(date[1] + '/' + date[0] + element.component.id);
              }
              element.month = date[1] + '/' + date[0];
              this.day = date[2];
              // if(element.metPlanCd==='IN')
              // {
              //   element.completedHours=undefined;
              // }
              element.metPlanCd = this.metPlanDescJson[element.metPlanCd];
              if (element.completedHours !== undefined && element.completedHours !== null) {
                element.completedHours = parseFloat(element.completedHours).toFixed(2);
              }

              element.component.authorizedHours = parseFloat(element.component.authorizedHours).toFixed(2);
            });

            this.validationError = [];
            this.showError = false;
            this.gridApi.setRowData(this.trackData);

          } else {
            this.trackData = [];

          }

          if (data !== null && data.component !== null && data.component.length > 0) {
            this.component = data.component;
          }
        }
      }, response => {

        this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Month', width: 130, field: 'month',
      },
      {
        headerName: 'Component', field: 'component.componentCd',
        refData: this.componentTypeDescJson, width: 230, valueGetter: this.getComponentType,
      },
      {
        headerName: 'Authorized', width: 130, field: 'component.authorizedHours'
      },
      {
        headerName: 'Reported', width: 130, field: 'reportedHours',cellRenderer: function(params) {
          if(params.data.finSw == 'Y'){
            return params.data.reportedHours;
          }
          else{
            return null;
          }
        }
      },
      {
        headerName: 'Completed', width: 130, field: 'completedHours',
         cellEditor: 'hoursEditor', editable: ((!(this.isDisabled || this.readOnly)) &&
          function (params) {
            const metPlan = params.data.metPlanCd;

            if (metPlan === 'No - GC Not Granted' || metPlan === 'No - GC Granted') {
              return false;
            } else {
              return true;
            }

          }),
        cellStyle: function (params) {

          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if(!(that.isDisabled || that.readOnly) && params.value !== undefined && !that.isShowStyle) {
              return { border: '1px solid #aaa',
              borderRadius: '4px',
              boxShadow:"inset 1px 2px 8px rgba(0, 0, 0, 0.07)"};
            }
            if (that.isShowStyle && (params.value === null && !(params.data.metPlanCd === 'In Progress'))) {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
          // if (params.data.completedHours !== null && params.data.completedHours>0) {
          //   if (params.data.completedHours >= params.data.component.authorizedHours) {
          //     params.data.metPlanCd = 'Yes';
          //   } else {
          //     params.data.metPlanCd = 'No';
          //   }
          // } else {
          //   params.data.metPlanCd = 'In Progress';

          // }
        }
      },

      {
        headerName: 'Met Plan?', width: 130, field: 'metPlanCd', editable: ((!(this.isDisabled || this.readOnly)) &&
          function (params) {
            const metPlan = params.data.metPlanCd;

            if (metPlan === 'No - GC Not Granted' || metPlan === 'No - GC Granted') {
              return false;
            } else {
              return true;
            }

          }), cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.metPlanArray,

        },
        cellStyle: function (params) {

          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if(!(that.isDisabled || that.readOnly) && params.value !== undefined && !that.isShowStyle) {
              return { border: '1px solid #aaa',
              borderRadius: '4px',
              boxShadow:"inset 1px 2px 8px rgba(0, 0, 0, 0.07)"};
            }
            if (that.isShowStyle && params.value === 'Pick an option') {
              return { border: '1px solid red' };
            } else {
              return { border: 'none', boxShadow: 'none' };
            }
          }

        }
      },
      {
        headerName: 'Action', width: 90, field: '', cellRenderer: this.getEditButton,
        suppressFilter: true,
        suppressSorting: true
      },

    ];

    this.context = {
      component: this,
    };
    this.rowSelection = 'multiple';

    this.frameworkComponents = {

      hoursEditor: HoursEditorComponent
    };
    this.gridOptions = <GridOptions>{};
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  auditColumnDefinations() {
    this.auditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Component Month',
        field: 'month',
        valueGetter: this.getMonth,
        tooltip: this.getMonth
      },
      {
        headerName: 'Component',
        field: 'component.componentCd',
        refData: this.componentTypeDescJson,
        tooltip: (params) => {
          const componentTypeDescMap = params.context.componentTypeDescJson;
          const componentTypeCode = params.data.component.componentCd;
          const componentType = componentTypeDescMap[componentTypeCode];
          return componentType;
        }
      },
      {
        headerName: 'Authorized Hours',
        field: 'component.authorizedHours',
        tooltipField: 'component.authorizedHours'
      },
      {
        headerName: 'Completed Hours',
        field: 'completedHours',
        tooltipField: 'completedHours'
      },
      {
        headerName: 'Met Plan',
        field: 'metPlanCd',
        refData: this.metPlanDescJson,
        tooltip: (params) => {
          const trackStatusDescMap = params.context.metPlanDescJson;
          const trackStatusCode = params.data.metPlanCd;
          const trackStatus = trackStatusDescMap[trackStatusCode];
          return trackStatus;
        }
      },
    ];
  }

  getMonth(params) {
    const date = params.data.month.trim().split('/');
    return date[1] + '/' + date[0];
  }

  formatMonth(params) {
    const month = params.value;
    console.log(month);
  }

  getEditButton(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');


    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TrackComponent');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Track Component Audit');
      that.router.navigate(['/task/componentSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.TrackComponent');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Track Component Audit');
        that.router.navigate(['/task/componentSummary/auditHistory']);
      }
    });
    auditElement.setAttribute('tabindex', '0');

    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol2);

    return divRow;
  }

  reset() {
    if (this.empPlanId > 0) {

      this.load(new RequestLoad(this.empPlanId, this.empStartDt, this.empEndDt,'N'));

    }
  }
  focus(event) {
    const enterKeyCode = 13;
    const spaceKeyCode = 32;
    if (event.keyCode === enterKeyCode || event.keyCode === spaceKeyCode) {
      this.saveAll();
    }
    event.preventDefault();
    setTimeout(() => this.header.nativeElement.focus(), 0);
    this.header.nativeElement.click();
  }

  getStatus(params) {

    const that = params.context.component;
    return that.trackStatusDescMap.get(params.data.metPlanCd);
  }

  getComponentType(params) {

    const that = params.context.component;
    return that.componentTypeDescMap.get(params.data.component.componentCd);
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }
  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridApi.columnDefs = this.columnDefs;
    } else {
      this.gridApi.sizeColumnsToFit();
    }
  }
  addEventListenerToSearch(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.trackData.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }
   getMonths = (fromDate, toDate) => {
    const fromYear = fromDate.getFullYear();
    const fromMonth = fromDate.getMonth();
    const toYear = toDate.getFullYear();
    const toMonth = toDate.getMonth();
    const months = [];
    for(let year = fromYear; year <= toYear; year++) {
      let month = year === fromYear ? fromMonth : 0;
      const monthLimit = year === toYear ? toMonth : 11;
      for(; month <= monthLimit; month++) {
        let day = null;
        fromDate.getDate() < 10 ? day = '0' + fromDate.getDate() : day = fromDate.getDate();
        months.push({year:year, month:(month + 1) < 10 ? '0' + (month + 1) : month + 1 , day:day});
      }
    }
    return months;
  }

  addTrackComponent() {
    const trackSize = this.trackData.length;
    this.component.forEach(componentObj => {
      if (componentObj !== undefined && componentObj.startDt !== undefined) { //Ticket 64680 changes (Madhu Voleti)
        //const startDate = this.dateUtil.convertDateFromServer(componentObj.startDt);
        //const estimatedCompletionDate = this.dateUtil.convertDateFromServer(componentObj.estimatedCompletionDt);
        //const currentDate = this.dateUtil.getSystemDateFromModel();
        componentObj.authorizedHours = parseFloat(componentObj.authorizedHours).toFixed(2);
        this.getMonths(new Date(componentObj.startDt),new Date(componentObj.estimatedCompletionDt)).forEach((month)=>{
          if(!this.isMonthExist.includes(month.month + '/' + month.year.toString() + componentObj.id) && ((Number(month.year) < new Date().getFullYear()) ||
                        ((Number(month.month) <= new Date().getMonth() + 1) && Number(month.year) == new Date().getFullYear()))){
            this.isMonthExist.push(month.month + '/' + month.year.toString() + componentObj.id);
              const monthObj = this.dateUtil.convertDateForServer({ year: month.year, month: Number(month.month), day: Number(month.day) });

              this.trackData.push(new TrackComponent(componentObj,
                monthObj,null, undefined, 'IN', 'N','N'));
          }
        })
        /*if (startDate.month <= currentDate.month && startDate.year === currentDate.year) {

          const startDt = new Date(startDate.year, startDate.month - 1, startDate.day);
          const endDt = new Date(estimatedCompletionDate.year, estimatedCompletionDate.month - 1, estimatedCompletionDate.day);

          /*for (let start = startDate.month; start <= currentDate.month && (start <= estimatedCompletionDate.month); start++) {*/
          /*for (let start = startDate.month; start <= currentDate.month && (start <= estimatedCompletionDate.month); start++) {
            if (start < 10) {
              start = '0' + start;
            }
            if (!this.isMonthExist.includes(start + '/' + startDate.year + componentObj.id)) {
              this.isMonthExist.push(start + '/' + startDate.year + componentObj.id);
              const monthObj = this.dateUtil.convertDateForServer({ year: startDate.year, month: Number(start), day: startDate.day });

              this.trackData.push(new TrackComponent(componentObj,
                monthObj,null, undefined, 'IN', 'N','N'));
            }

          } 
        } else if (startDate.year < currentDate.year) {



          for (let start = startDate.month; start <= 12; start++) {
            if (start < 10) {
              start = '0' + start;
            }
            if (!this.isMonthExist.includes(start + '/' + startDate.year + componentObj.id)) {
              this.isMonthExist.push(start + '/' + startDate.year + componentObj.id);
              const monthObj = this.dateUtil.convertDateForServer({ year: startDate.year, month: Number(start), day: startDate.day });

              this.trackData.push(new TrackComponent(componentObj,
                monthObj,null, undefined, 'IN', 'N','N'));
            }
          }

          let nextYear = startDate.year + 1;
          const startMonth = 1;

          for (let start = startMonth; start <= currentDate.month
            && (start <= estimatedCompletionDate.month) && (nextYear <= estimatedCompletionDate.year); start++) {
            let startStr;
            if (start < 10) {
              startStr = '0' + start;
            }
            else if(start == 12){
              nextYear = nextYear + 1;
            } else {
              startStr = start;
            }
            if (!this.isMonthExist.includes(startStr + '/' + nextYear + componentObj.id)) {
              this.isMonthExist.push(startStr + '/' + nextYear + componentObj.id);
              const monthObj = this.dateUtil.convertDateForServer({ year: nextYear, month: start, day: startDate.day });

              this.trackData.push(new TrackComponent(componentObj,
                monthObj,null, undefined, 'IN', 'N','N'));
            }
          }
        }*/
      }
    });


    if (this.trackData.length > trackSize) {
      this.trackData.forEach(element => {
        if (element.month.trim().length === 7) {
          const month = element.month.trim().split('/');
          element.month = month[1] + '/' + month[0] + '/' + this.day;

        }
        // if(element.completedHours===undefined)
        // {
        //   element.completedHours=0;
        // }
        if (element.id !== undefined) {
          element.metPlanCd = this.trackStatusDescReverseJson[element.metPlanCd];
        }


      });



      const request = new RequestLoadAll(this.trackData, this.component);
      this.http.post<TrackComponent[]>(this.serverConstants.SERVER_API_URL + '/component/track-save', request).subscribe(
        (data) => {
          if (data.hasOwnProperty('errorCode')) {
            this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
          } else {
            this.notificationService.success('Track Component', this.userActionNotificationsMap.ADD);
            if (this.employmentPlan.id > 0) {
              const requestLoad = new RequestLoad(this.employmentPlan.id,
                this.employmentPlan.empPlanStartDt, this.employmentPlan.estimatedCompletionDt,'N');
              this.load(requestLoad);

            }
          }
        }, response => {

          this.notificationService.error('Track Component', this.userActionNotificationsMap.ERROR);
        }, () => {

        });
    } else {
      this.notificationService.warn('Track Component', 'No records added');
    }

  }


  toggleMultiselctDDKeyboard(event: KeyboardEvent) {
    const KEY_UP = 38;
    const KEY_DOWN = 40;
    const multiselectDDElement = (<HTMLElement>event.target);


    if (event.altKey) {
      if (event.keyCode === KEY_DOWN || event.keyCode === KEY_UP) {
        const multisectDDChildNodes = multiselectDDElement.querySelectorAll('.dropdown-list');
        let hiddenAttrsFound = false;

        if (multisectDDChildNodes) {
          for (let i = 0; i < multisectDDChildNodes.length; i++) {
            if ((<HTMLElement>multisectDDChildNodes[i]).hasAttribute('hidden')) {
              hiddenAttrsFound = true;
              break;
            }
          }

          for (let i = 0; i < multisectDDChildNodes.length; i++) {
            if (hiddenAttrsFound) {
              multisectDDChildNodes[i].removeAttribute('hidden');
            } else {
              multisectDDChildNodes[i].setAttribute('hidden', '');
            }
          }
        }
      }
    }
  }
  openModal(){
    var modal = document.getElementById("myModal");
      modal.style.display = "block";
  }
  closeModal(){
    var modal = document.getElementById("myModal");
    modal.style.display = "none";
  }
  createAlert(){
    let requestArray = [];
    console.log(this.alerts);
    console.log(this.alertsClone);
    this.alerts.forEach((element)=>{
      let request = {
        createdBy: sessionStorage.getItem("FirstName"),
        description:"Hours has been denied for " + this.componentTypeDescMap.get(element.component.componentCd) + " for the month of "+ element.month.trim().split('/')[1] + '/' + element.month.trim().split('/')[0],
        personId:Number(this.sharedData.get('wpPersonId'))
      }
      requestArray.push(request);
    });
    console.log(requestArray);
    if(requestArray.length > 0){
      this.http.post(this.serverConstants.CITIZEN_API_URL+"/alerts/save",requestArray).subscribe((data)=>{
        if(data["message"]=="success"){
          this.notificationService.success('Track Component', "Alert Created for Citizen");
        }
        else{
          this.notificationService.error('Track Component', "Unable to create alert for citizen");
        }
      },error=>{
        this.notificationService.error('Track Component', "Unable to create alert for citizen");
      })
    }
    
  }

}

class TrackComponent {
  constructor(
    public component: Components,
    public month: any,
    public completedHours: any,
    public reportedHours: any,
    public metPlanCd: string,
    public deleteSw: string,
    public finSw:string

  ) {

  }
}
class RequestLoadAll {
  constructor(
    public tracks: TrackComponent[],
    public component: Components[],
    public oldTask?: Task
  ) {
  }
}

class RequestLoad {
  constructor(
    public id: Number,
    public start_dt?: any,
    public end_dt?: any,
    public fin_sw?:'N'

  ) {
  }
}

class RequestLoadAllEmpPlans {
  constructor(
    public personId: Number
  ) {
  }
}


// WEBPACK FOOTER //
// ./src/app/track-component/track-component.component.ts